/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const GST_RATE = 0.15;

export function addGST(price: number): number {
  const gst = price * GST_RATE;
  const totalPrice = price + gst;
  return totalPrice;
}

export const getGST = (price: number) => {
  const gst = price * GST_RATE;
  return gst;
};

export const extractGST = (priceIncludingGST: number) => {
  const priceExcludingGST = priceIncludingGST / (1 + GST_RATE);
  const gst = priceIncludingGST - priceExcludingGST;
  return gst;
};

export const removeGST = (priceIncludingGST: number) => {
  return priceIncludingGST / (1 + GST_RATE);
};
